import React, { Component } from "react";
import { Spinner } from "react-bootstrap";
import logo from "../../media/logo.png";
import moment from "moment";
import settings from "../../settings";
import PropTypes from "prop-types";
import LoadingSpinner from "./LoadingSpinner";

class LoadingSpinnerOverlay extends Component {
  constructor(props) {
    super(props);
  }

  _overlayClasses = () =>
    ["position-fixed", "p-4", "w-100", "h-100", "overflow-hidden", "d-flex", "d-flex", "justify-content-center", "align-items-center"].join(
      " "
    );

  _style = () => ({
    zIndex: 9999,
    top: 0,
    right: 0,
    backgroundColor: `rgba(233,233,233, ${this.props.bgOpacity || 0.4})`
  });

  render() {
    return (
      <div className="position-relative">
        <div className={this._overlayClasses()} style={this._style()}>
          <LoadingSpinner
            className="d-flex justify-content-center align-items-center"
            animation={this.props.animation}
            variant={this.props.variant}
            size={this.props.size}
          />
        </div>
      </div>
    );
  }
}

LoadingSpinnerOverlay.propTypes = {
  animation: PropTypes.string,
  variant: PropTypes.string,
  size: PropTypes.string,
  bgOpacity: PropTypes.number
};

export default LoadingSpinnerOverlay;
